/* eslint-disable no-unused-vars */
import React from 'react';
import { NavLink } from 'react-router-dom';

import {
  UilCreateDashboard,
  UilBell,
  UilFileEditAlt,
  UilSuitcaseAlt,
  UilNewspaper,
  UilUniversity,
  UilConstructor,
  UilBookAlt,
  UilCreditCard,
  UilFileUpload,
  // UilFileEdit,
} from '@iconscout/react-unicons';

function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}

const mMenu = [
  getItem(<NavLink to="/dashboard">Dashboard</NavLink>, 'dashboard', <UilCreateDashboard />, null, 'dashboard'),
  getItem('Companies', 'Companies', <UilSuitcaseAlt />, [
    getItem(<NavLink to="/companies">List All</NavLink>, '', null),
    getItem(<NavLink to="/comp-fps">Focal Persons</NavLink>, 'comp-fps', null),
    getItem(<NavLink to="/comp-addresses">Addresses</NavLink>, 'comp-addresses', null),
    getItem(<NavLink to="/comp-atts">Attachments</NavLink>, 'comp-atts', null),
  ]),
  getItem(<NavLink to="/emps">Employees</NavLink>, 'emps', <UilConstructor />, null, 'emps'),
  getItem(<NavLink to="/t-centers">Training Centers</NavLink>, 't-centers', <UilUniversity />, null, 't-centers'),
  getItem(<NavLink to="/t-courses">Courses</NavLink>, 't-courses', <UilNewspaper />, null, 't-courses'),
  getItem(<NavLink to="/update-reqs">Update Requests</NavLink>, 'update-reqs', <UilFileEditAlt />, null, 'update-reqs'),
  // getItem(<NavLink to="/notifications">Notifications <span className='badge bg-red-400 !p-[4px] menuItem animate-pulse'> 1000 </span></NavLink>, 'notifications', <UilBell />, null, 'notifications'),
  getItem(<NavLink to="/emp-trainings">EMP Trainings</NavLink>, 'trainings', <UilBookAlt />, null, 'trainings'),
  getItem(<NavLink to="/e-cards">EMP Cards</NavLink>, 'cards', <UilCreditCard />, null, 'cards'),
  getItem(<NavLink to="/notifications">Notifications</NavLink>, 'notifications', <UilBell />, null, 'notifications'),
  getItem(<NavLink to="/document-categories">Document Categories</NavLink>, 'document-categories', <UilFileEditAlt />, null, 'document-categories'),
  getItem(<NavLink to="/important-docs">Important Documents</NavLink>, 'important-docs', <UilFileUpload />, null, 'important-docs'),
  getItem('Reports', 'Reports', <UilSuitcaseAlt />, [
    getItem(<NavLink to="/reports/comp-stats">Company Stats</NavLink>, '', null),
  ]),
];

export default mMenu